import { Download, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  ESCALATION_STATE_OPTIONS,
  LEAD_STATUS_OPTIONS,
  SERVICE_OPTIONS,
  STATUS_OPTIONS,
} from "./dashboardTokens";

const FilterSelect = ({ value, onValueChange, options, testId, width }) => (
  <Select value={value} onValueChange={onValueChange}>
    <SelectTrigger className={`h-10 ${width}`} data-testid={testId}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {options.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

/** Search box, the per-tab status filter, and the CSV export button. */
export const RecordFilters = ({ tab, filters, onExport }) => (
  <div data-testid="admin-filters" className="flex flex-wrap items-center gap-2">
    <div className="relative">
      <Search
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden="true"
      />
      <Input
        data-testid="admin-search-input"
        value={filters.query}
        onChange={(event) => filters.setQuery(event.target.value)}
        placeholder="Name, email, company, reference…"
        className="h-10 w-full pl-9 sm:w-[260px]"
      />
    </div>
    <FilterSelect
      value={filters.serviceFilter}
      onValueChange={filters.setServiceFilter}
      options={SERVICE_OPTIONS}
      testId="admin-service-filter"
      width="w-[180px]"
    />
    {tab === "sessions" ? (
      <FilterSelect
        value={filters.statusFilter}
        onValueChange={filters.setStatusFilter}
        options={STATUS_OPTIONS}
        testId="admin-status-filter"
        width="w-[220px]"
      />
    ) : null}
    {tab === "leads" ? (
      <FilterSelect
        value={filters.leadStatusFilter}
        onValueChange={filters.setLeadStatusFilter}
        options={LEAD_STATUS_OPTIONS}
        testId="admin-lead-status-filter"
        width="w-[220px]"
      />
    ) : null}
    {tab === "fallbacks" ? (
      <FilterSelect
        value={filters.escalationState}
        onValueChange={filters.setEscalationState}
        options={ESCALATION_STATE_OPTIONS}
        testId="admin-escalation-state-filter"
        width="w-[200px]"
      />
    ) : null}
    <Button type="button" onClick={onExport} data-testid="admin-export-csv-button" className="h-10">
      <Download className="mr-2 h-4 w-4" aria-hidden="true" />
      Export CSV
    </Button>
  </div>
);
